import React, { Fragment } from "react";
import { Container, Header, Segment } from "semantic-ui-react";
import { aFunAnswer, icanBeData, whyHire } from "../constants";

/**
 * @author
 * @function QueryAnswers
 **/

const QueryAnswers = ({value}) => {
  const reasonWhy = [
    { name: "Reason 1", text: `Hi there, ${whyHire}` },
    { name: "Reason 2", text: aFunAnswer },
    { name: "Reason 3", text: icanBeData },
    { name: "Get premium to know more", text: "Hahahh!! Just Kidding....." }
  ];
  return (
    <Fragment>
      <Container
        style={{
          boxShadow: "0px 3px 28px rgba(0, 0, 0, 0.04)",
          height: window.innerWidth <=800 ? "650px" : "",
          overflow: "auto",
          padding: "20px",
          marginBottom : "500px"
        }}
      >
          <Header
                style={{ color:"gold"}}
                textAlign="center"
              >
                THE GOLDEN REASONS
              </Header>
        {reasonWhy.map((whyre, index) => {
          return (
            <>
              <Segment style = {{marginBottom : index === reasonWhy.length - 1 ?"100px" : ""}}>
              <Header
                style={{ color: index === reasonWhy.length - 1 ? "gold" : "" }}
                textAlign="center"
              >
                {whyre.name}
              </Header>
                <p>
                  {/* <br /> */}
                  {whyre.text}
                </p>
              </Segment>
            </>
          );
        })}
      </Container>
    </Fragment>
  );
};

export default QueryAnswers;
